<script lang="ts" generics="ROW">
    import type {EnumValues} from 'src/typings';
    import type {Readable} from 'svelte/store';
    import type {Row, Table} from '@tanstack/svelte-table';
    import {clickOutside} from 'shared/svelte-actions';
    import {getRenderConfig} from './utils';
    import {getGridContext} from './grid.context';
    import {bindInputs, InputsController} from 'src/features/record-grid/lib/inputs-controller';
    import {Render} from 'svelte-render';
    import KpGenericGridRow from './KpGenericGridRow.svelte';
    import KpGenericGridCell from './grid-cell/KpGenericGridCell.svelte';

    export let table$: Readable<Table<ROW>>;

    const {stateManager, command$, settings: {rowClassTemplate}} = getGridContext<ROW>();
    const inputsController = new InputsController(stateManager, command$, table$);

    const ROW_COLOR = {
        LIGHT: 'light',
        DARK: 'dark'
    } as const;

    type RowColor = EnumValues<typeof ROW_COLOR>;

    let tableRows = [];
    $: tableRows = $table$.getRowModel().rows;

    let tableRowColors: RowColor[] = [];
    $: tableRowColors = resolveRowColors(tableRows);

    function resolveRowColors(rows: Row<ROW>[]): RowColor[] {
        const rowColors: RowColor[] = [];

        for (let currentRowIndex = 0; currentRowIndex < rows.length; currentRowIndex++) {
            rowColors.push(resolveRowColor(currentRowIndex, rows, rowColors));
        }

        return rowColors;
    }

    function resolveRowColor(currentRowIndex: number, rows: Row<ROW>[], rowColors: RowColor[]): RowColor {
        if (currentRowIndex === 0) {
            return ROW_COLOR.LIGHT;
        }

        const currentRow = rows.at(currentRowIndex);
        const previousIndex = currentRowIndex - 1;
        const previousRow = rows.at(previousIndex);
        const previousRowColor = rowColors.at(previousIndex);
        if (currentRow.depth !== previousRow.depth) {
            return flipColor(previousRowColor);
        } else {
            return previousRowColor;
        }
    }

    function flipColor(rowColor: RowColor) {
        if (rowColor === ROW_COLOR.DARK) {
            return ROW_COLOR.LIGHT;
        } else {
            return ROW_COLOR.DARK;
        }
    }
</script>

<div class="kp-generic-grid-body"
     use:clickOutside={{ignoredElementsSelectors: ['dialog', '.context-menu', '.grid-bottom-toolbar']}}
     use:bindInputs={inputsController}>

    {#each tableRows as row, rowIndex (row.id)}
        <KpGenericGridRow cssClass={rowClassTemplate(row)}>
            {#each row.getVisibleCells() as cell, columnIndex (cell.id)}
                <KpGenericGridCell {cell} {rowIndex} {columnIndex} baseBackgroundColor={tableRowColors.at(rowIndex)}>
                    <Render of={getRenderConfig(cell.column.columnDef.cell, cell.getContext())}/>
                </KpGenericGridCell>
            {/each}
        </KpGenericGridRow>
    {/each}
</div>